{
  "labels": {
    "paste": "Qoyıw",
    "pasteAsPlaintext": "Ápiwayı tekst retinde qoyıw",
    "pasteCharts": "Diagrammalardı qoyıw",
    "selectAll": "Barlıǵın tańlaw",
    "multiSelect": "",
    "moveCanvas": "",
    "cut": "Qıyıw",
    "copy": "Kóshirip alıw",
    "copyAsPng": "Almasıw buferine PNG retinde kóshirip alıw",
    "copyAsSvg": "Almasıw buferine SVG retinde kóshirip alıw",
    "copyText": "Almasıw buferine tekst retinde kóshirip alıw",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "",
    "sendToBack": "",
    "bringToFront": "",
    "sendBackward": "",
    "delete": "Óshiriw",
    "copyStyles": "",
    "pasteStyles": "",
    "stroke": "Jiyek",
    "background": "Fon",
    "fill": "",
    "strokeWidth": "",
    "strokeStyle": "",
    "strokeStyle_solid": "",
    "strokeStyle_dashed": "",
    "strokeStyle_dotted": "",
    "sloppiness": "",
    "opacity": "",
    "textAlign": "",
    "edges": "Qırlar",
    "sharp": "",
    "round": "",
    "arrowheads": "",
    "arrowhead_none": "Joq",
    "arrowhead_arrow": "Jebe",
    "arrowhead_bar": "",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "Shrift ólshemi",
    "fontFamily": "Shrift toplamı",
    "addWatermark": "",
    "handDrawn": "",
    "normal": "",
    "code": "Kod",
    "small": "",
    "medium": "Ortasha",
    "large": "Úlken",
    "veryLarge": "Júdá úlken",
    "solid": "",
    "hachure": "",
    "zigzag": "Zigzag",
    "crossHatch": "",
    "thin": "Jińishke",
    "bold": "Qalıń",
    "left": "",
    "center": "",
    "right": "",
    "extraBold": "",
    "architect": "",
    "artist": "Súwretshi",
    "cartoonist": "",
    "fileTitle": "Fayl ataması",
    "colorPicker": "Reńdi tańlaw",
    "canvasColors": "",
    "canvasBackground": "",
    "drawingCanvas": "",
    "layers": "Qatlamlar",
    "actions": "Háreketler",
    "language": "Til",
    "liveCollaboration": "",
    "duplicateSelection": "Nusqa",
    "untitled": "Atamasız",
    "name": "Ataması",
    "yourName": "Atıńız",
    "madeWithExcalidraw": "Excalidraw járdeminde islengen",
    "group": "",
    "ungroup": "",
    "collaborators": "Qatnasıwshılar",
    "showGrid": "",
    "addToLibrary": "Kitapxanaǵa qosıw",
    "removeFromLibrary": "Kitapxanadan alıp taslaw",
    "libraryLoadingMessage": "Kitapxana júklenbekte…",
    "libraries": "Kitapxanalardı kóriw",
    "loadingScene": "Saxna júklenbekte…",
    "align": "",
    "alignTop": "",
    "alignBottom": "",
    "alignLeft": "",
    "alignRight": "",
    "centerVertically": "",
    "centerHorizontally": "",
    "distributeHorizontally": "",
    "distributeVertically": "",
    "flipHorizontal": "",
    "flipVertical": "",
    "viewMode": "Kóriw rejimi",
    "share": "Bólisiw",
    "showStroke": "",
    "showBackground": "",
    "toggleTheme": "Temanı ózgertiw",
    "personalLib": "Jeke kitapxana",
    "excalidrawLib": "Excalidraw kitapxanası",
    "decreaseFontSize": "Shrift ólshemin kishireytiw",
    "increaseFontSize": "Shrift ólshemin úlkeytiw",
    "unbindText": "",
    "bindText": "",
    "createContainerFromText": "",
    "link": {
      "edit": "Siltemeni ózgertiw",
      "editEmbed": "",
      "create": "Siltemeni jaratıw",
      "createEmbed": "",
      "label": "Silteme",
      "labelEmbed": "",
      "empty": ""
    },
    "lineEditor": {
      "edit": "Qatardı ózgertiw",
      "exit": "Qatardı ózgertiw redaktorınan shıǵıw"
    },
    "elementLock": {
      "lock": "Qulıplaw",
      "unlock": "Qulıptan shıǵarıw",
      "lockAll": "Barlıǵın qulıplaw",
      "unlockAll": "Barlıǵın qulıptan shıǵarıw"
    },
    "statusPublished": "",
    "sidebarLock": "",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "",
    "hint_emptyLibrary": "",
    "hint_emptyPrivateLibrary": ""
  },
  "buttons": {
    "clearReset": "",
    "exportJSON": "",
    "exportImage": "Súwretti eksportlaw...",
    "export": "Retinde saqlaw...",
    "copyToClipboard": "Almasıw buferine kóshirip alındı",
    "save": "Ámeldegi faylǵa saqlaw",
    "saveAs": "Retinde saqlaw",
    "load": "Ashıw",
    "getShareableLink": "",
    "close": "Jabıw",
    "selectLanguage": "Tildi tańlaw",
    "scrollBackToContent": "",
    "zoomIn": "",
    "zoomOut": "",
    "resetZoom": "",
    "menu": "Menyu",
    "done": "Tayın",
    "edit": "Ózgertiw",
    "undo": "",
    "redo": "",
    "resetLibrary": "",
    "createNewRoom": "",
    "fullScreen": "Tolıq ekran",
    "darkMode": "Qarańǵı tema",
    "lightMode": "Jaqtı tema",
    "zenMode": "",
    "objectsSnapMode": "",
    "exitZenMode": "",
    "cancel": "Biykarlaw",
    "clear": "Tazalaw",
    "remove": "Óshiriw",
    "embed": "",
    "publishLibrary": "Jariyalaw",
    "submit": "Jiberiw",
    "confirm": "Tastıyıqlaw",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "",
    "couldNotCreateShareableLink": "",
    "couldNotCreateShareableLinkTooBig": "",
    "couldNotLoadInvalidFile": "",
    "importBackendFailed": "",
    "cannotExportEmptyCanvas": "",
    "couldNotCopyToClipboard": "Almasıw buferine kóshirip alıw ámelge aspadı.",
    "decryptFailed": "",
    "uploadedSecurly": "",
    "loadSceneOverridePrompt": "",
    "collabStopOverridePrompt": "",
    "errorAddingToLibrary": "",
    "errorRemovingFromLibrary": "",
    "confirmAddLibrary": "",
    "imageDoesNotContainScene": "",
    "cannotRestoreFromImage": "",
    "invalidSceneUrl": "",
    "resetLibrary": "",
    "removeItemsFromsLibrary": "",
    "invalidEncryptionKey": "",
    "collabOfflineWarning": ""
  },
  "errors": {
    "unsupportedFileType": "",
    "imageInsertError": "",
    "fileTooBig": "",
    "svgImageInsertError": "",
    "failedToFetchImage": "",
    "invalidSVGString": "Jaramsız SVG.",
    "cannotResolveCollabServer": "",
    "importLibraryError": "Kitapxananı júklew ámelge aspadı",
    "collabSaveFailed": "",
    "collabSaveFailed_sizeExceeded": "",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "",
    "image": "Súwret qoyıw",
    "rectangle": "Tórt múyeshlik",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "Sızıq",
    "freedraw": "Sızıw",
    "text": "Tekst",
    "library": "Kitapxana",
    "lock": "",
    "penMode": "",
    "link": "",
    "eraser": "Óshirgish",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "",
    "extraTools": "",
    "mermaidToExcalidraw": "",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "",
    "selectedShapeActions": "",
    "shapes": "Figuralar"
  },
  "hints": {
    "canvasPanning": "",
    "linearElement": "",
    "freeDraw": "",
    "text": "",
    "embeddable": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "placeImage": "",
    "publishLibrary": "",
    "bindTextToElement": "Tekst qosıw ushın Enter túymesin basıń",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "Aldınnan kóriwdi kórsetiw múmkin emes",
    "canvasTooBig": "",
    "canvasTooBigTip": ""
  },
  "errorSplash": {
    "headingMain": "",
    "clearCanvasMessage": "",
    "clearCanvasCaveat": "",
    "trackedToSentry": "",
    "openIssueMessage": "",
    "sceneContent": ""
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "",
    "button_stopSession": "",
    "desc_inProgressIntro": "",
    "desc_shareLink": "",
    "desc_exitSession": "",
    "shareTitle": ""
  },
  "errorDialog": {
    "title": "Qátelik"
  },
  "exportDialog": {
    "disk_title": "Diskke saqlaw",
    "disk_details": "",
    "disk_button": "Faylǵa saqlaw",
    "link_title": "",
    "link_details": "",
    "link_button": "Siltemege eksportlaw",
    "excalidrawplus_description": "",
    "excalidrawplus_button": "Eksportlaw",
    "excalidrawplus_exportError": ""
  },
  "helpDialog": {
    "blog": "Biziń blogtı oqıń",
    "click": "basıw",
    "deepSelect": "",
    "deepBoxSelect": "",
    "curvedArrow": "",
    "curvedLine": "",
    "documentation": "Hújjetshilik",
    "doubleClick": "",
    "drag": "",
    "editor": "Redaktor",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "",
    "howto": "",
    "or": "yamasa",
    "preventBinding": "",
    "tools": "Ásbaplar",
    "shortcuts": "",
    "textFinish": "",
    "textNewLine": "",
    "title": "Járdem",
    "view": "Kóriw",
    "zoomToFit": "",
    "zoomToSelection": "",
    "toggleElementLock": "",
    "movePageUpDown": "",
    "movePageLeftRight": ""
  },
  "clearCanvasDialog": {
    "title": ""
  },
  "publishDialog": {
    "title": "",
    "itemName": "",
    "authorName": "Avtor atı",
    "githubUsername": "GitHub paydalanıwshı atı",
    "twitterUsername": "Twitter paydalanıwshı atı",
    "libraryName": "Kitapxana ataması",
    "libraryDesc": "",
    "website": "Veb-sayt",
    "placeholder": {
      "authorName": "Atıńız yamasa paydalanıwshı atı",
      "libraryName": "Kitapxanańız ataması",
      "libraryDesc": "",
      "githubHandle": "",
      "twitterHandle": "",
      "website": "Jeke veb-saytıńız yamasa basqa saytqa silteme (májbúriy emes)"
    },
    "errors": {
      "required": "Májbúriy",
      "website": "Jaramlı URL mánzil kirgiziń"
    },
    "noteDescription": "",
    "noteGuidelines": "",
    "noteLicense": "",
    "noteItems": "",
    "atleastOneLibItem": "",
    "republishWarning": ""
  },
  "publishSuccessDialog": {
    "title": "Kitapxana jiberildi",
    "content": ""
  },
  "confirmDialog": {
    "resetLibrary": "Kitapxananı qayta ornatıw",
    "removeItemsFromLib": ""
  },
  "imageExportDialog": {
    "header": "Súwretti eksportlaw",
    "label": {
      "withBackground": "Fon",
      "onlySelected": "",
      "darkMode": "Qarańǵı tema",
      "embedScene": "",
      "scale": "Kólem",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Almasıw buferine kóshirip alıw"
    }
  },
  "encrypted": {
    "tooltip": "",
    "link": ""
  },
  "stats": {
    "angle": "",
    "element": "Element",
    "elements": "Elementler",
    "height": "",
    "scene": "Saxna",
    "selected": "Tańlandı",
    "storage": "",
    "title": "",
    "total": "",
    "version": "Versiya",
    "versionCopy": "Kóshirip alıw ushın basıń",
    "versionNotAvailable": "",
    "width": "Eni"
  },
  "toast": {
    "addedToLibrary": "Kitapxanaǵa qosıldı",
    "copyStyles": "",
    "copyToClipboard": "Almasıw buferine kóshirip alındı.",
    "copyToClipboardAsPng": "",
    "fileSaved": "Fayl saqlandı.",
    "fileSavedToFilename": "{filename} saqlandı",
    "canvas": "",
    "selection": "",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": ""
  },
  "colors": {
    "transparent": "",
    "black": "Qara",
    "white": "Aq",
    "red": "Qızıl",
    "pink": "Qızǵılt",
    "grape": "",
    "violet": "Qızǵılt kók",
    "gray": "",
    "blue": "Kók",
    "cyan": "Kók aspan",
    "teal": "Piruza",
    "green": "Jasıl",
    "yellow": "Sarı",
    "orange": "Qızǵılt sarı",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_plus": "Excalidraw+ ge ótiwdi qáleysiz be?",
      "menuHint": "Eksportlaw, sazlawlar, tiller, ..."
    },
    "defaults": {
      "menuHint": "Eksportlaw, sazlawlar hám basqa...",
      "center_heading": "Diagrammalar. Ápiwayı.",
      "toolbarHint": "",
      "helpHint": ""
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "Kóp qollanılatuǵın arnawlı reńler",
    "colors": "Reńler",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Súwret retinde eksportlaw",
        "button": "Súwret retinde eksportlaw",
        "description": ""
      },
      "saveToDisk": {
        "title": "Diskke saqlaw",
        "button": "Diskke saqlaw",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Fayldan júklew",
        "button": "Fayldan júklew",
        "description": ""
      },
      "shareableLink": {
        "title": "Siltemeden júklew",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": ""
  }
}
